export const hash = '7f343974-5755-4fbe-bc41-9ae8f7f23284';

// export const gateKey = '';
export const gateKey = '';
export const recaptchaKey = '6LdjeDYcAAAAAIBkqkyJP37Ki4QdCflMC9kjCMe7';
export const apiUrl = `https://api-global-v2.encontrodigital.com.br/${hash}`;
export const apiSocket = 'https://socket-2023.encontrodigital.com.br';
//export const apiSocket = 'http://localhost:8001';

//export const apiUrl = `http://localhost:8000/${hash}`;
export const urlWebsite = 'https://36-simposio-oftalmo-hcpa.encontrodigital.com.br';
export const supportNumber = `5551981476007`;

export const defaultProjectHash = '36-simposio-de-oftalmologia-do-hcpa';

export const home = 'Home';
export const haveTranslate = false;
// export const urlWebsite = 'http://localhost:3000';
export const eventName = '36º Simpósio de Oftalmologia do HCPA';
export const logo = '/assets/logo-padrao.jpeg';
export const background = '/assets/Fundo.jpeg';
export const authTitle = '36º Simpósio de Oftalmologia do HCPA';
export const dadosOrganizacao = '';
export const social = {
  whatsapp: '',
  instagram: '',
  facebook: '',
  linkedin: '',
  youtube: '',
  twitter: '',
};


export const defaultTheme = {
  defaultBackground: '#134842',
  defaultColor: '#134842',
  logo: {
    minWidth: '450px',
  },
  menu: {
    background: '#134842',
    backgroundSticky: '#fff',
    backgroundMobile: '#fff',
    color: '#134842',
    shadow: '0',
    logoColor: '#134842',
  },
};

export const getToken = (): string | null => {
  const token = localStorage.getItem(`@${authTitle}:token`);
  return token;
};
